import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchGeneralSettingsAPI } from "./generalSettingsAPI";

export const fetchGeneralSettingsData = createAsyncThunk(
    "settings/fetchGeneralSettingsData",
    async () => {
        const data = await fetchGeneralSettingsAPI();
        return data
    }
)

const generalSettingsSlice = createSlice({
    name: "general_settings",
    initialState: {
        generalSettings: {},
        loading: false,
        error: null
    },

    reducers: {},

    extraReducers: (builder) => {
        builder
        .addCase(fetchGeneralSettingsData.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchGeneralSettingsData.fulfilled, (state, action) => {
            state.loading = false;
            state.generalSettings = action.payload.data || {};
        })
        .addCase(fetchGeneralSettingsData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        })
    }
})

export default generalSettingsSlice.reducer;